import styled from 'styled-components'

export const DescriptionDiv = styled.div`
display:flex;
justify-content:center;
text-align:center;

min-height: 200px;
h2{
color: #02021C;


p{
    text-align: center;
    font-feature-settings: 'liga' off;
    color: #18191F;

   
}

}

`